export default "__VITE_ASSET__Bl5pY6tn__"